import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgForIn } from './ng-for-in';

@NgModule({
  declarations: [ NgForIn ],
  imports: [ CommonModule ],
  exports: [ NgForIn ],
})
export class ContribNgForInModule { }
